



















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
  },
  props: {
    fileBoxes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileBoxLoading: false,
    };
  },

  methods: {
    async addFileBox() {
      this.fileBoxLoading = true;
      const examId = parseInt(this.$route.params.examId);
      await this.$store.dispatch('ADD_FILE_BOX_BY_EXAM_ID', examId);
      this.fileBoxLoading = false;
    },
    async editFileBoxes(fileBoxes: any) {
      this.fileBoxLoading = true;
      const incorrectFileBox = this.fileBoxes.find(
        fileBox => fileBox.name !== 'respostas_assinadas' || !fileBox.mandatory,
      );
      await this.$store.dispatch('UPDATE_FILE_BOX', incorrectFileBox.id);
      this.fileBoxLoading = false;
    },
    checkIfFileBoxIsCorrect(fileBox: any) {
      return fileBox.name === 'respostas_assinadas' && fileBox.mandatory;
    },
  },
});
